import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteVehicleWithdrawal(
  uuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/vehicle-withdrawal/${uuid}`)
}
